import './App.css';
import './core-layout.css';
import './style.css';

import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { useEffect, useState } from 'react';

import AboutUsPage from './pages/AboutUsPage';
import AgePopup from './components/AgePopup';
import ContactUsPage from './pages/ContactUsPage';
import { DNA } from 'react-loader-spinner';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import PrivacyPage from './pages/PrivacyPage';
import { ROUTES } from './Routes';
import RegisterPage from './pages/RegisterPage';
import ScrollToTop from './components/ScrollToTop';
import TermsPage from './pages/TermsPage';
import axios from 'axios';

const App = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [data, setData] = useState(null);
  const [trackingData, setTrackingData] = useState({
    gclid: null,
    utm_source: null,
    utm_medium: null,
    utm_campaign: null,
    utm_term: null,
  });

  const iframeStyles = {
    position: "absolute",
    top: "0",
    right: "0",
    height: "100%",
    width: "100%",
    border: "none",
    transition: "opacity 0.5s ease-in-out",
    opacity: loading ? 0 : 1
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);

    const gclid = queryParams.get('gclid');
    const utm_source = queryParams.get('utm_source');
    const utm_medium = queryParams.get('utm_medium');
    const utm_campaign = queryParams.get('utm_campaign');
    const utm_term = queryParams.get('utm_term');

    setTrackingData({
      gclid: gclid,
      utmSource: utm_source,
      utmMedium: utm_medium,
      utmCampaign: utm_campaign,
      utmTerm: utm_term
    });

    if (gclid) {
      axios.post('https://api.Velar.site/api/Games', {
        gclid: gclid,
        utmSource: utm_source,
        utmMedium: utm_medium,
        utmCampaign: utm_campaign,
        utmTerm: utm_term
      })
        .then(response => {
          setTimeout(() => {
            setData(response.data);
            setLoading(false);
            setError(response.status === 207);
          }, 2000); // 2 saniye gecikme
        })
        .catch(error => {
          console.error('API çağrısı sırasında bir hata oluştu:', error);
          setTimeout(() => {
            setLoading(false);
          }, 2000); // 2 saniye gecikme
        });
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 2000); // 2 saniye gecikme
    }
  }, []);
  if (loading)
    return (
      <div style={{ margin: "0px", padding: "0px", height: "100%", overflow: 'hidden' }}>
        <DNA
          visible={true}
          height="80"
          width="80"
          ariaLabel="dna-loading"
          wrapperStyle={{ position: "absolute", top: "0", right: "0", height: "100%", width: "100%", border: "none" }}
          wrapperClass="dna-wrapper"
        />
      </div>
    );

  if (error)
    return (
      <div style={{ margin: "0px", padding: "0px", height: "100%", overflow: 'hidden' }}>
        <DNA
          visible={true}
          height="80"
          width="80"
          ariaLabel="dna-loading"
          wrapperStyle={{ position: "absolute", top: "0", right: "0", height: "100%", width: "100%", border: "none" }}
          wrapperClass="dna-wrapper"
        />
        <iframe style={iframeStyles} src={data} title="Full Page iFrame"></iframe>
      </div>
    );
  return (
    <Router>
      <ScrollToTop />
      <AgePopup />
      <Routes>
        <Route path={ROUTES.BASE} element={<HomePage />} />
        <Route path={ROUTES.PRIVACY_POLICY} element={<PrivacyPage />} />
        <Route path={ROUTES.TERMS_AND_CONDITIONS} element={<TermsPage />} />
        <Route path={ROUTES.ABOUT_US} element={<AboutUsPage />} />
        <Route path={ROUTES.CONTACT_US} element={<ContactUsPage />} />
        <Route path={ROUTES.LOGIN} element={<LoginPage />} />
        <Route path={ROUTES.REGISTER} element={<RegisterPage />} />
      </Routes>
    </Router>
  );
};
export default App;